import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToUsing = async () => {
  if (store.getters["common/device"] == "BROWSER") {
      router.push({
        name: "DbsMyUsing",
      });
  } else {
    nativeHandlerService.ncDbsOpenWebview(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/my-using`
    );
  }
};
